import styled, {ThemeProps} from 'styled-components';
import {Theme} from './../../../../theme/types';
import {Column} from './../../common/Layouts/Layouts';

export const ProgressBarInnerWrapperDiv = styled(Column)`
  width: 27rem;
  height: 0.8rem;
  background-color: ${props => props.theme.colors.ash.medium};
  border-radius: ${props => props.theme.misc.borderRadius.large};
  position: absolute;
`;

// export const ProgressLine = (props: ThemeProps<Theme>) => `
//   background-color: ${props.bgColor};
//   border-radius: ${props.theme.misc.borderRadius.large};
//   position: relative;
//   height: 0.8rem;
//   width: ${props.width}rem;
// `;

export const ProgressLine = styled.span(
  (props: ThemeProps<Theme>) => `
  background-color: ${props.bgColor};
  border-radius: ${props.theme.misc.borderRadius.large};
  position: relative;
  height: 0.8rem;
  width: ${props.width}rem;
`,
);
